import { useFormLayoutLabels } from "@/contexts";
import { MuxRegPlus } from "@/Icons";

interface IAddSectionProps {
  onAddSection: () => void;
  disabled?: boolean;
}

export const AddSection = ({ onAddSection, disabled }: IAddSectionProps) => {
  const labels = useFormLayoutLabels();
  return (
    <button
      type="button"
      className="add-section-button"
      disabled={disabled}
      onClick={onAddSection}
    >
      <MuxRegPlus />
      {labels.addSection}
    </button>
  );
};
